/* Eyeshells Fancybox (Ultra Stable)
 * Fancybox: @fancyapps/ui (v6.x)
 *
 * Goals:
 * - Toolbar buttons always clickable
 * - Backdrop click closes (standard behavior)
 * - Zoom works when image is zoomable
 * - No side-effects to collection / quickview pages
 */

(function () {
  "use strict";

  function isProductPage() {
    var cls = (document.body && document.body.className) ? document.body.className : "";
    if (cls.indexOf("template-product") !== -1) return true;
    if (/\/products\//i.test(window.location.pathname)) return true;
    return false;
  }

  // We only lightbox explicit fancybox links (PDP gallery anchors).
  // Keeping it scoped avoids any impact to collections / quickview.
  var SELECTOR = "a[data-fancybox]";

  // Normalize common YouTube URL formats so Fancybox can always detect the provider.
  // Especially: https://www.youtube.com/shorts/<id>  ->  https://youtu.be/<id>
  function normalizeYouTubeUrl(url) {
    if (!url || typeof url !== "string") return url;
    var u = url.trim();

    // Shorts format
    // Examples:
    //  - https://www.youtube.com/shorts/VIDEOID
    //  - https://youtube.com/shorts/VIDEOID?si=xxxx
    //  - https://m.youtube.com/shorts/VIDEOID
    var shortsMatch = u.match(/(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]{6,})/i);
    if (shortsMatch && shortsMatch[1]) {
      return "https://youtu.be/" + shortsMatch[1];
    }

    // Standard watch URL (kept as-is, but trimmed)
    //  - https://www.youtube.com/watch?v=VIDEOID
    //  - https://youtube.com/watch?v=VIDEOID&...
    var watchMatch = u.match(/(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/watch\?[^#]*v=([a-zA-Z0-9_-]{6,})/i);
    if (watchMatch && watchMatch[1]) {
      return "https://youtu.be/" + watchMatch[1];
    }

    return u;
  }

  function normalizeFancyboxUrls() {
    try {
      var nodes = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        var a = nodes[i];
        if (!a) continue;
        var href = a.getAttribute("href") || "";
        if (!href) continue;
        if (href.indexOf("youtube") === -1 && href.indexOf("youtu.be") === -1) continue;
        var fixed = normalizeYouTubeUrl(href);
        if (fixed && fixed !== href) {
          a.setAttribute("href", fixed);
        }
      }
    } catch (e) {}
  }

  function isDesktop() {
    try {
      return window.matchMedia && window.matchMedia("(min-width: 990px)").matches;
    } catch (e) {
      return true;
    }
  }

  function cleanupDuplicateClose(container) {
    if (!container) return;
    try {
      // 1) If the toolbar somehow ends up with multiple close buttons (rare, but can happen
      // with custom templates or app injections), keep only the last one.
      try {
        var tbClose = container.querySelectorAll(
          ".fancybox__toolbar [data-fancybox-close], " +
          ".fancybox__toolbar [aria-label='Close'], " +
          ".fancybox__toolbar [title='Close']"
        );
        if (tbClose && tbClose.length > 1) {
          for (var k = 0; k < tbClose.length - 1; k++) {
            tbClose[k].style.display = "none";
          }
        }
      } catch (e) {}

      var all = container.querySelectorAll("button, a");
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        var isClose = el.hasAttribute("data-fancybox-close") ||
          el.getAttribute("aria-label") === "Close" ||
          el.getAttribute("title") === "Close" ||
          el.className.indexOf("close") !== -1;

        if (!isClose) continue;
        // Keep the toolbar close; hide any other close buttons rendered inside slides
        if (el.closest && el.closest(".fancybox__toolbar")) continue;
        if (el.closest && el.closest(".fancybox__thumbs")) continue;
        // If it's inside the slide/content, hide it
        el.style.display = "none";
      }
    } catch (e) {}
  }

  var OPTIONS = {
    animated: true,
    hideScrollbar: true,
    dragToClose: true,
    // IMPORTANT:
    // Fancybox `closeButton:true` creates an extra close (X) above the content.
    // Since we already provide a Close button via Toolbar.display (right: [..., "close"]),
    // enabling both results in a duplicate X on the top-right.
    // So we disable the extra close button and keep ONLY the toolbar close.
    closeButton: false,

    // Keep classic behavior
    backdropClick: "close",
    contentClick: "toggleZoom",
    contentDblClick: false,

    // Avoid hash changes / history weirdness on Shopify
    Hash: false,

    // Keyboard mapping (Windows intuition)
    // Fancybox default maps PageUp -> next and PageDown -> prev
    // We flip it to match expected behavior: PageUp=previous, PageDown=next
    keyboard: {
      Escape: "close",
      Delete: "close",
      Backspace: "close",
      PageUp: "prev",
      PageDown: "next",
      ArrowUp: "prev",
      ArrowDown: "next",
      ArrowRight: "next",
      ArrowLeft: "prev",
    },

    // Slideshow / Play button reliability
    // Prevent "hover pauses autoplay" effect on desktop, and slow it slightly
    Slideshow: {
      timeout: 3500,
      Autoplay: {
        timeout: 3500,
        pauseOnHover: false,
      },
    },

    // Make sure zoom is enabled for images
    Images: {
      zoom: true,
    },

    // Allow a meaningful zoom even when images are not ultra-high-res,
    // so the magnifier cursor doesn't feel "broken".
    Panzoom: {
      maxScale: 3,
    },

    Carousel: {
      infinite: false,
      friction: 0.86,
    },

    Thumbs: {
      autoStart: isDesktop(),
    },

    Toolbar: {
      display: {
        left: ["infobar"],
        middle: [],
        right: ["zoom", "slideshow", "fullscreen", "thumbs", "close"],
      },
    },

    on: {
      // FIX: blur PDP VIDEO/360 trigger after Fancybox close (prevents stuck :focus styles)
      closing: function () {
        try {
          var ae = document.activeElement;
          if (ae && ae.blur && ae.classList && (ae.classList.contains("btn-video") || ae.classList.contains("btn-360"))) {
            ae.blur();
          }
        } catch (e) {}
      },
      destroy: function () {
        try {
          var ae = document.activeElement;
          if (ae && ae.blur && ae.classList && (ae.classList.contains("btn-video") || ae.classList.contains("btn-360"))) {
            ae.blur();
          }
        } catch (e) {}
      },
ready: function (fancybox) {
        cleanupDuplicateClose(fancybox && fancybox.container);
      },
      done: function (fancybox) {
        cleanupDuplicateClose(fancybox && fancybox.container);
      },
    },
  };

  function bindFancybox() {
    if (!isProductPage()) return;
    if (!window.Fancybox || typeof window.Fancybox.bind !== "function") return;

    // Make sure YouTube Shorts / watch links are converted into a Fancybox-friendly format.
    normalizeFancyboxUrls();

    // Safe re-bind (Shopify theme editor / PJAX)
    try {
      if (typeof window.Fancybox.unbind === "function") {
        window.Fancybox.unbind(SELECTOR);
      }
    } catch (e) {}

    window.Fancybox.bind(SELECTOR, OPTIONS);
  }

  function boot() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      bindFancybox();

      if (window.Fancybox && typeof window.Fancybox.bind === "function") {
        window.clearInterval(timer);
      }
      if (tries > 60) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function () {
    bindFancybox();
  });
})();
